module.exports = __webpack_public_path__ + "oprah.png?0eb594613af99b57e5eae1e816dd9d67";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oprah.png
// module id = 214
// module chunks = 0